import { SET_FOOTER_LIST } from "../constants";

export const setFooterList = (payload) => ({
  type: SET_FOOTER_LIST,
  payload,
});